var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-popover',{attrs:{"placement":_vm.placement,"title":_vm.title,"width":_vm.width,"trigger":_vm.trigger}},[_c('div',[_vm._t("default")],2),_vm._v(" "),_c('img',{style:(_vm.tipStyle),attrs:{"slot":"reference","src":"/static/icon/helpIcon.png","alt":"提示"},slot:"reference"})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-762085b3","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/publicTips/popoverTip.vue
// module id = null
// module chunks = 